import { useGetSearchLeftActions } from '@modules/feed/components/SearchAnalysisToolbar/hooks/useGetSearchLeftActions';
import { useGetSearchMoreActions } from '@modules/feed/components/SearchAnalysisToolbar/hooks/useGetSearchMoreActions';
import { useGetSearchRightActions } from '@modules/feed/components/SearchAnalysisToolbar/hooks/useGetSearchRightActions';

export default function useGetSearchAnalysisActions() {
  const leftActions = useGetSearchLeftActions();
  const rightActions = useGetSearchRightActions();
  const moreActions = useGetSearchMoreActions();

  return {
    leftActions,
    rightActions,
    moreActions,
  };
}
